import Link from "next/link";
import { linkStyle } from "@/styles/sharedStyle";
import { useRouter } from "next/router";
import { getUrlWithQuery } from "@/libs/url";
import config from "@/libs/config";

type Props = {
  app?: string;
  text?: string;
};

export const ProvisionalRegistrationLink = (props: Props) => {
  const router = useRouter();
  let { app } = router.query;
  let text = "Mikatano シリーズを新規登録するにはこちらへ";

  if (props.app) {
    app = props.app;
  }
  if (props.text) {
    text = props.text;
  }

  return (
    <Link href={getUrlWithQuery("/provisional-registration", app)}>
      <span css={linkStyle}>
        {config.BANK_NICKNAME} {text}
      </span>
    </Link>
  );
};
